import type { Client } from '@bugsnag/js'

export const useErrorNotifier = (): Client => {
  try {
    // bugsnag is disabled in development, so it does not export the `useBugsnag` composable
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return useBugsnag()
  } catch {
    return {
      notify: (...args: unknown[]) => {
        console.error(...args)
      },
    } as unknown as Client
  }
}
